import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ProviderActivationEventName } from '@uplift/api';
import { useCurrentuser } from '@uplift/contexts';
import { useIsMobile, useL10n } from '@uplift/hooks';
import { useProviderActivationEvents } from '@uplift/queries';

import { useDashboardStyles } from '../../dashboard-page/styles';
import { ToDosList } from '../../dashboard-page/to-dos/components';
import { hasEvent } from '../helpers';
import { TodoItem } from '../types';
import { OnboardingTask } from './OnboardingTask';

export type ToDoStepSectionProps = {
  toDos: TodoItem[];
};

export const ToDoStepSection: React.VFC<ToDoStepSectionProps> = ({ toDos }) => {
  const l10n = useL10n();
  const isMobile = useIsMobile();
  const { classes } = useStyles();
  const { classes: dashboardClasses } = useDashboardStyles();

  const me = useCurrentuser();
  const { data: events } = useProviderActivationEvents(me?.id);
  const isCredentialingApproved = hasEvent(events, ProviderActivationEventName.credentialingApproved);

  const toDoItems = toDos.map((toDo, index) => <OnboardingTask key={index} {...toDo} />);
  const isStateSelectionToDoLeft = toDos.length === 1 && toDos[0].task === 'stateSelection' && !isCredentialingApproved;

  return (
    <Box>
      <Box mb={3} mt={isMobile ? 5 : 0} ml={isMobile ? 2 : 0}>
        <Typography variant="h3" className={classes.title}>
          <span className={dashboardClasses.secondary}>{toDoItems.length}</span>
          &nbsp;{l10n.dashboard.toDo.items(toDoItems?.length)}&nbsp;{l10n.dashboard.toDo.toDo}
        </Typography>
        <Typography variant="body1" color="textSecondary" >
          {isStateSelectionToDoLeft ? l10n.providerSettings.onboarding.finishAfterCredentialingApproved : l10n.providerSettings.onboarding.taskReminder}
        </Typography>
      </Box>
      <ToDosList toDos={toDoItems} />
    </Box>
  );
};

const useStyles = makeStyles()(theme => ({
  title: {
    fontSize: '1.25rem',
    marginBottom: '0.5rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '1.5rem',
    },
  },
}));
